import Vue from 'vue';

export default {
    SET_AUTOCOMPLETE_ADRESSES: (state, autocompleteAdresses) => {
        state.autocompleteAdresses = autocompleteAdresses;
    },

    SET_ORDER_HISTORIES: (state, orderHistories) => {
        state.orderHistories = orderHistories;
    },

    SET_CLIENT_STATUSES_HISTORY: (state, clientStatusesHistory) => {
        state.clientStatusesHistory = clientStatusesHistory;
    },

    SET_GROUP_ORDERS_COORDS: (state, groupOrdersCoords) => {
        state.groupOrdersCoords = groupOrdersCoords;
    },

    ClEAR_GROUP_ORDERS_COORDS: (state) => {
        state.groupOrdersCoords = [];
    },

    SET_ORDER_DRIVERS: (state, orderDrivers) => {
        state.orderDrivers = orderDrivers;
    },

    SET_FILTERED_ORDER_DRIVERS: (state, filteredOrderDrivers) => {
        state.filteredOrderDrivers = filteredOrderDrivers;
    },

    SET_BRAND_DETAILS: (state, brandDetails) => {
        state.brandDetails = brandDetails;
    },

    SET_POLYLINE: (state, polyline) => {
        state.polyline = polyline;
    },

    SET_ORDER_LINES: (state, lines) => {
        state.lines = lines;
    },

    SET_COORDINATES: (state, coordinates) => {
        state.coordinates = coordinates;
    },

    SET_ALL_ORDERS: (state, allOrders) => {
        state.allOrders = allOrders;
    },

    SET_IS_SHOW_HISTORY: (state, isShowHistory) => {
        state.isShowHistory = isShowHistory;
    },

    SET_ADDRESS_COORDS: (state, { latitude, longitude }) => {
        state.addressCoords = {
            latitude, longitude
        };
    },

    SET_CALL_SIGN: (state, callSign) => {
        state.driverCallSign = callSign;
    },

    SET_ACTIVE_DRIVER: (state, driver) => {
        state.activeDriver = driver;
    },

    CLEAR_ADDRESS_COORDS: (state) => {
        state.addressCoords = {
            latitude: null,
            longitude: null
        };
    },

    SET_ACTIVE_ORDER_ADDRESSES: (state, addresses) => {
        state.activeOrderAddresses = !addresses.length ? [{}]: addresses;
    },

    SET_ACTIVE_ORDER_ADDRESS_PROPS: (state, { index, prop, value }) => {
        const newDate = Object.assign({}, state.activeOrderAddresses[index], {
            [prop]: value
        });

        Vue.set(state.activeOrderAddresses, index, newDate);
    },

    UPDATE_ACTIVE_ORDER_ADDRESS: (state, { index, data }) => {
        Vue.set(state.activeOrderAddresses, index, data);
    },

    ADD_ACTIVE_ORDER_ADDRESS: (state) => {
        state.activeOrderAddresses = state.activeOrderAddresses.concat([{}]);
    },

    REMOVE_ACTIVE_ORDER_ADDRESS: (state, index) => {
        if (state.activeOrderAddresses.length > 1) {
            state.activeOrderAddresses.splice(index, 1);
        }
    }
};
